import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Component, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { ForgotPasswordRequest } from '../../../security/models';
import { SecurityService } from '../../../security/services/security.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  formTouched = false;
  formSubmitted = false;
  email: string;
  showSuccess: boolean = false;
  userNotFound: boolean = false;

  constructor(
    private securityService: SecurityService,
    @Inject('IMAGES_URL') public imagesUrl: string,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}
  getImage = () => "url('assets/images/texture-1.png')";
  ngOnInit() {}

  onSubmit(form: any): void {
    this.userNotFound = false;

    if (!form.valid) {
      this.formTouched = true;
      return;
    }

    this.formSubmitted = true;
    this.securityService.forgotPassword(this.email).subscribe(
      (res) => {
        this.showSuccess = true;
      },
      (err: HttpErrorResponse) => {
        if (err.status == 404) this.userNotFound = true;
        this.formSubmitted = false;
      }
    );
  }
}
